import React from "react";
import Common_Banner from "../common-components/common_banner/Common_Banner"; // ✅ Import banner
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";

const PrivacyPolicy = () => {
  return (
    <div className="terms-wrapper">
      {/* ✅ Replaced old banner with Common_Banner */}
      {/* <Common_Banner
        imgSrc="/assets/images/privacypolicy/privacy.png"
        title="Terms & Conditions"
      /> */}

      <Common_Banner_2 imgSrc="/assets/images/about_us/banner/Banner-01.png" title_text="Privacy Policy" />

      <div className="container mt-5">
        {/* Content Section */}

        <h1>Privacy Policy</h1>
        <p class="updated">Last Updated: 11/06/2026</p>

        <p>
          Nutripair India Pvt Ltd ("Company", "we", "our", or "us") respects your privacy and is committed
          to protecting your personal information. This Privacy Policy explains how we collect, use,
          disclose, store, and protect information when you access or use our Website.
        </p>

        <p>
          By accessing or using this Website, you consent to the practices described in this Privacy Policy.
        </p>

        <h2>1. About This Website</h2>
        <p>
          This Website is intended to provide information about Nutripair products, brands,
          initiatives, and related content.
        </p>

        <p>
          Nutripair India Pvt Ltd does not currently sell products directly through this Website.
          Users may be redirected to third-party marketplaces, retailers, or delivery platforms such as
          Amazon, Flipkart, Blinkit, or other authorized partners to complete purchases.
          Any transactions conducted on such third-party platforms are governed by their respective
          terms and privacy policies.
        </p>

        <h2>2. Information We Collect</h2>

        <h5>Information You Voluntarily Provide</h5>
        <p>We may collect personal information that you voluntarily submit through:</p>

        <ul>
          <li>Contact forms</li>
          <li>Business inquiry forms</li>
          <li>Distributor or retailer inquiry forms</li>
          <li>Customer support requests</li>
          <li>Feedback forms</li>
          <li>Email communications</li>
        </ul>

        <p>Such information may include:</p>

        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Mobile number</li>
          <li>Company or business name</li>
          <li>City and state</li>
          <li>Any information included in your message or inquiry</li>
        </ul>

        <h5>Automatically Collected Information</h5>
        <p>
          When you visit our Website, we may automatically collect certain information including:
        </p>

        <ul>
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Device information</li>
          <li>Operating system</li>
          <li>Pages visited</li>
          <li>Date and time of visit</li>
          <li>Referral source</li>
          <li>Website usage analytics</li>
        </ul>

        <p>
          This information helps us improve Website performance and user experience.
        </p>

        <h2>3. How We Use Your Information</h2>

        <p>We may use collected information to:</p>

        <ul>
          <li>Respond to inquiries and requests.</li>
          <li>Communicate regarding products, services, or business opportunities.</li>
          <li>Improve Website performance and user experience.</li>
          <li>Analyze Website traffic and visitor behavior.</li>
          <li>Maintain Website security and prevent misuse.</li>
          <li>Comply with applicable legal and regulatory obligations.</li>
        </ul>

        <h2>4. Cookies and Tracking Technologies</h2>

        <p>
          This Website may use cookies and similar technologies to improve functionality,
          understand visitor behavior, analyze Website traffic, and enhance user experience.
        </p>

        <p>
          You may disable cookies through your browser settings; however, some Website features
          may not function properly.
        </p>

        <h2>5. Third-Party Marketplace and Website Links</h2>

        <p>
          Our Website may contain links to third-party marketplaces, retailers, social media
          platforms, or external websites.
        </p>

        <p>
          When you click on such links, you leave our Website and become subject to the policies
          and practices of those third parties.
        </p>

        <p>Nutripair India Pvt Ltd is not responsible for:</p>

        <ul>
          <li>Privacy practices of third-party websites.</li>
          <li>Information collected by third-party platforms.</li>
          <li>Security measures implemented by third parties.</li>
          <li>Products, services, or transactions conducted through such platforms.</li>
        </ul>

        <p>
          Users are encouraged to review the privacy policies of all third-party websites they visit.
        </p>

        <h2>6. Sharing of Information</h2>

        <p>We do not sell, rent, or trade personal information to third parties.</p>

        <p>We may share information with:</p>

        <ul>
          <li>Website hosting providers</li>
          <li>IT and technology service providers</li>
          <li>Analytics service providers</li>
          <li>Professional advisors</li>
          <li>Regulatory or government authorities where required by law</li>
        </ul>

        <p>
          Such disclosures are limited to the extent reasonably necessary for business operations
          or legal compliance.
        </p>

        <h2>7. Data Security</h2>

        <p>
          We implement reasonable administrative, technical, and organizational safeguards to protect
          personal information from unauthorized access, misuse, disclosure, alteration, or destruction.
        </p>

        <p>
          However, no method of internet transmission or electronic storage can be guaranteed to be
          completely secure. Users acknowledge that information transmitted online is done at their own risk.
        </p>

        <h2>8. Data Retention</h2>

        <p>We retain personal information only for as long as reasonably necessary to:</p>

        <ul>
          <li>Respond to inquiries</li>
          <li>Fulfill legitimate business purposes</li>
          <li>Maintain records</li>
          <li>Comply with legal and regulatory obligations</li>
        </ul>

        <p>
          Information that is no longer required may be securely deleted or anonymized.
        </p>

        <h2>9. Your Rights</h2>

        <p>
          Subject to applicable laws, including the Digital Personal Data Protection Act, 2023 (India),
          you may have the right to:
        </p>

        <ul>
          <li>Request access to your personal information.</li>
          <li>Request correction of inaccurate information.</li>
          <li>Request deletion of personal information.</li>
          <li>Withdraw consent where applicable.</li>
          <li>Request information regarding how your personal information is used.</li>
        </ul>

        <h2>10. Children's Privacy</h2>

        <p>
          This Website is not intended for individuals below 18 years of age.
          We do not knowingly collect personal information from children.
          If such information is identified, reasonable steps will be taken to delete it.
        </p>

        <h2>11. Consent Notice</h2>

        <p>
          By submitting any form on this Website, you consent to the collection, storage,
          and processing of the information provided by you for the purpose of responding to your inquiry,
          providing relevant information, and improving our services.
        </p>

        <h2>12. Marketplace Disclaimer</h2>

        <p>
          Nutripair India Pvt Ltd does not currently sell products directly through this Website.
          Product purchase links may redirect users to third-party marketplaces or retail partners.
        </p>

        <p>
          All purchases, payments, deliveries, returns, refunds, cancellations, and related services
          are governed solely by the policies and terms of the respective marketplace or seller.
          Nutripair India Pvt Ltd shall not be liable for any issues arising from transactions
          conducted on third-party platforms.
        </p>

        <h2>13. Website Disclaimer</h2>

        <p>
          The information provided on this Website is for general informational purposes only.
          While Nutripair India Pvt Ltd makes reasonable efforts to ensure the accuracy of the
          information presented, we make no representations or warranties regarding its completeness,
          reliability, or suitability.
        </p>

        <p>
          Nutritional and product-related information should not be considered medical advice and
          should not replace consultation with qualified healthcare professionals.
        </p>

        <h2>14. Changes to This Privacy Policy</h2>

        <p>
          We reserve the right to modify or update this Privacy Policy at any time.
          Any revisions will be posted on this page with an updated "Last Updated" date.
          Continued use of the Website after changes are posted constitutes acceptance of the
          revised Privacy Policy.
        </p>

        <h2>15. Contact Us</h2>

        <div class="contact-box">
          <p><strong>Nutripair India Pvt Ltd</strong></p>
          <p><strong>Email:</strong> nutripair@nutripair.in, nutripair.india@gmail.com</p>
          <p><strong>Phone:</strong> +91 9604663885</p>
          <p><strong>Address:</strong> Paygude Compound, 4/2/762, Bhairavnath Nagar,
            Kondhwe Dhawde, Pune, Maharashtra - 411023, India</p>
        </div>




      </div>
    </div>
  );
};

export default PrivacyPolicy;
